import React from 'react';
import { SyncIcon } from '../Components';
import AppContext from '../AppContext';

const Sync = () => (
    <AppContext.Consumer>
      {({ actions }) => (
        <>
          <SyncIcon onClick={actions.resync} />
        </>
      )}
    </AppContext.Consumer>
);

export default Sync;
